import type { AnimationSpeed, AssistanceLevel, UserPreferences } from '@texas42/app-model';
import { ANIMATION_SPEED_OPTIONS, ASSISTANCE_OPTIONS } from '@texas42/app-model';

export const SETTINGS_COPY = {
  storageTitle: 'Local storage',
  storageBody:
    'Texas 42 keeps saved games, stats, rulesets, and preferences on this device only. Nothing is uploaded to a server. Export a backup before clearing data or switching browsers.',
  exportLabel: 'Export backup',
  importLabel: 'Import backup',
  resetStatsTitle: 'Reset all stats?',
  resetStatsBody:
    'This clears your match history and performance data. Saved games are not deleted.',
  resetGrandadTitle: 'Reset learned tendencies?',
  resetGrandadBody: 'Grandad will forget your playing patterns. Stats are not affected.',
  aboutTitle: 'About',
  aboutBody: 'Texas 42 brings partnership dominoes to your screen. Play against computer opponents, learn the game, and revisit your hands.',
  privacyLabel: 'Privacy statement',
  diagnosticsLabel: 'Export diagnostics',
  diagnosticsBody:
    'Download app information and recent errors to share when you need help. Nothing is uploaded automatically.',
  cacheResetTitle: 'Reset offline cache',
  cacheResetBody:
    'Clear the downloaded app files. Your saved games and statistics stay on this device.',
  cacheResetLabel: 'Clear offline cache',
} as const;

export const KEYBOARD_SHORTCUTS = [
  { keys: '?', description: 'Open keyboard shortcut help (from Settings)' },
  { keys: 'Tab', description: 'Move focus between interactive controls' },
  { keys: 'Enter / Space', description: 'Activate the focused button or domino' },
  { keys: 'Escape', description: 'Close the topmost dialog or drawer' },
] as const;

export function animationSpeedOptionsForSettings(): Array<{
  value: AnimationSpeed;
  label: string;
}> {
  return ANIMATION_SPEED_OPTIONS.filter((option) => option.value !== 'reduced');
}

export function assistanceOptionsForSettings(): Array<{
  value: AssistanceLevel;
  label: string;
}> {
  return ASSISTANCE_OPTIONS;
}

export function resolveReducedMotion(preferences: UserPreferences): boolean {
  return preferences.reducedMotion || preferences.animationSpeed === 'reduced';
}

export function resolveLargeDominoMode(preferences: UserPreferences): boolean {
  return preferences.largeDominoMode;
}

export function resolveColorfulPips(preferences: UserPreferences): boolean {
  return preferences.colorfulPips === true;
}

export function normalizeAnimationSpeed(preferences: UserPreferences): AnimationSpeed {
  if (preferences.reducedMotion) {
    return 'reduced';
  }
  return preferences.animationSpeed === 'reduced' ? 'normal' : preferences.animationSpeed;
}
